import { tokenRefreshService } from './token-refresh.service';

const prepare = (response) => {
  return response
    .json()
    .then((json) => [response, json])
    .catch(() => [response, {}]);
};

const status = ([response, json]) => {
  if (response.status < 200 || response.status >= 300) {
    // Prefer 'message' over 'error' since our API uses 'message' for user-facing errors
    const message =
      json?.message || json?.error || 'An error occurred. Please try again.';
    const error = new Error(message);
    return Promise.reject(error);
  }
  return Promise.resolve([response, json]);
};

const json = ([response, jsonData]) => {
  if (response.status !== 204) {
    return jsonData;
  }
  return {};
};

export const getAuthHeaders = () => {
  const authToken = localStorage.getItem('authToken');
  const authHeader = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };
  if (authToken) {
    authHeader['Authorization'] = `Bearer ${authToken}`;
  }
  return authHeader;
};

export const getBaseHeaders = (headers) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    if (typeof token !== 'undefined') {
      headers.set('authorization', `Bearer ${token}`);
    }
  }
  return headers;
};

const xhr = async (url, params = {}) => {
  // Try to refresh token if needed before making request
  // Skip for auth endpoints to avoid circular dependency
  const isAuthEndpoint =
    url.includes('/auth/refresh') ||
    url.includes('/auth/logout') ||
    url.includes('/users/authenticate');

  if (!isAuthEndpoint) {
    try {
      await tokenRefreshService.refreshTokenIfNeeded();
    } catch {
      // Token refresh failed - continue with request anyway
      // It will fail with 401 which triggers logout
    }
  }

  let authToken;
  if (typeof localStorage === 'undefined') {
    authToken = null;
  } else {
    authToken = localStorage.getItem('authToken');
  }
  let authHeader = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };
  if (authToken) {
    authHeader = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`,
      },
    };
  }
  if (!params.headers) {
    Object.assign(params, authHeader);
  }
  return fetch(url, params).then(prepare).then(status).then(json);
};

export default xhr;
